import walletPurchaseBandsTemplate from './wallet_purchase_bands.html';

function WalletPurchaseBandsDirective($rootScope) {
    'ngInject';

    function link(scope, attr, elem, ctrl) {

        scope.member = scope.$eval(attr.member);
        if ($rootScope.member) {
            if (!scope.member) {
                scope.member = $rootScope.member;
            }
        }

        return $rootScope.connection_started.then(() => {
            if (ctrl) {
                let deregisterWatch;
                return deregisterWatch = scope.$watch('wallet', () => {
                    if (scope.wallet) {
                        scope.getWalletPurchaseBandsForWallet(scope.wallet);
                        return deregisterWatch();
                    }
                });
            } else {
                return scope.getWalletForMember(scope.member).then(() => scope.getWalletPurchaseBandsForWallet(scope.wallet));
            }
        });
    }

    return {
        scope: true,
        restrict: 'AE',
        templateUrl: walletPurchaseBandsTemplate.id,
        controller: 'Wallet',
        require: '^?bbWallet',
        link
    };
}

angular
    .module('BB')
    .directive('bbWalletPurchaseBands', WalletPurchaseBandsDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/wallet-purchase-bands/wallet_purchase_bands.directive.js